import React from 'react';
import { classNames } from '../../utils/format';

export default function Button({
  variant = 'ghost',
  size = 'md',
  type = 'button',
  className,
  disabled,
  loading,
  children,
  iconLeft,
  iconRight,
  fullWidth,
  ...rest
}) {
  return (
    <button
      type={type}
      className={classNames(
        'ui-btn',
        `ui-btn--${variant}`,
        `ui-btn--${size}`,
        fullWidth && 'ui-btn--block',
        (disabled || loading) && 'is-disabled',
        className
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="ui-btn__spinner" aria-hidden />}
      {!loading && iconLeft && <span className="ui-btn__icon">{iconLeft}</span>}
      <span className="ui-btn__label">{children}</span>
      {!loading && iconRight && <span className="ui-btn__icon">{iconRight}</span>}
    </button>
  );
}
